import { createApi } from "@reduxjs/toolkit/query/react";
import { gql } from "graphql-request";

import customBaseQuery from "../../../../utils/customBaseQuery";

export const SocialInteractionsApiSlice = createApi({
  reducerPath: "socialInteractionsApiSlice",
  baseQuery: customBaseQuery,
  refetchOnFocus: true,
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    addToFavourites: builder.mutation({
      query: ({ id }: { id: string }) => ({
        method: "POST",
        url: `/bookmark/${id}`
      }),
      extraOptions: { service: "Social_Interactions" }
    }),
    removeFromFavourites: builder.mutation({
      query: ({ ids }: { ids: string[] }) => ({
        method: "DELETE",
        url: `/bookmark`,
        body: ids
      }),
      extraOptions: { service: "Social_Interactions" }
    }),
    getInteractions: builder.query({
      query: ({
        contentId,
        requiredQuery = `data {
                userId
                contentId
                interactions {
                  bookmarked
                  bookmarkedAt
                  reactionType
                  sharedWith {
                    userId
                    email
                    sharedAt
                    sharedAtZoneId
                    name
                  }
                  sharedBy {
                    userId
                    email
                    sharedAt
                    sharedAtZoneId
                    name
                  }
                }
              }`
      }: any) => ({
        url: "/graphql",
        params: {
          variables: {
            contentId: contentId,
            shareDataNotRequired: true
          }
        },
        body: gql`
          query GetInteractions(
            $contentId: String!
            $shareDataNotRequired: Boolean!
          ) {
            getInteractions(
              contentId: $contentId
              shareDataNotRequired: $shareDataNotRequired
            ) {
              ${requiredQuery}
            }
          }
        `
      }),
      extraOptions: { service: "Social_Interactions" }
    }),
    addReaction: builder.mutation({
      query: ({
        contentId,
        reactionType
      }: {
        contentId: string;
        reactionType: string;
      }) => ({
        url: `/reaction/${contentId}/${reactionType}`,
        method: "POST"
      }),
      extraOptions: { service: "Social_Interactions" }
    }),
    removeReaction: builder.mutation({
      query: ({ contentId }: { contentId: string }) => ({
        url: `/reaction/${contentId}`,
        method: "DELETE"
      }),
      extraOptions: { service: "Social_Interactions" }
    }),
    getStatsForContent: builder.query({
      query: ({ contentId }: { contentId: string }) => ({
        url: `/stats/${contentId}`,
        method: "GET"
      }),
      extraOptions: { service: "Social_Interactions" }
    }),
    getInteractionsStatsForContent: builder.query({
      query: ({ contentId }: { contentId: string }) => ({
        url: `/stats/interactions/${contentId}`,
        method: "GET"
      }),
      extraOptions: { service: "Social_Interactions" }
    }),
    shareContent: builder.mutation({
      query: ({ body }) => ({
        url: `/share`,
        method: "POST",
        body: body
      }),
      extraOptions: { service: "Social_Interactions" }
    })
  })
});

export const {
  useAddToFavouritesMutation,
  useRemoveFromFavouritesMutation,
  useGetInteractionsQuery,
  useLazyGetInteractionsQuery,
  useAddReactionMutation,
  useRemoveReactionMutation,
  useGetStatsForContentQuery,
  useLazyGetStatsForContentQuery,
  useGetInteractionsStatsForContentQuery,
  useLazyGetInteractionsStatsForContentQuery,
  useShareContentMutation
} = SocialInteractionsApiSlice;
